"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLighterColor = void 0;
const RGB_REGEX = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
const clamp = (value) => Math.min(255, Math.max(0, Math.round(value)));
const sanitiseColor = (color) => {
    const colorSanitised = color.replace('#', '');
    if (colorSanitised.length > 3) {
        return colorSanitised;
    }
    return colorSanitised
        .split('')
        .map((char) => char + char)
        .join('');
};
const interpolate = (r, g, b, fraction) => {
    const lr = clamp(r + (255 - r) * fraction);
    const lg = clamp(g + (255 - g) * fraction);
    const lb = clamp(b + (255 - b) * fraction);
    return `#${lr.toString(16).padStart(2, '0')}${lg.toString(16).padStart(2, '0')}${lb.toString(16).padStart(2, '0')}`;
};
const getLighterColor = (color, fraction) => {
    if (color.startsWith('#')) {
        const colorSanitised = sanitiseColor(color);
        const r = parseInt(colorSanitised.substring(0, 2), 16);
        const g = parseInt(colorSanitised.substring(2, 4), 16);
        const b = parseInt(colorSanitised.substring(4, 6), 16);
        return interpolate(r, g, b, fraction);
    }
    const rgbMatch = color.match(RGB_REGEX);
    if (rgbMatch) {
        const r = parseInt(rgbMatch[1], 10);
        const g = parseInt(rgbMatch[2], 10);
        const b = parseInt(rgbMatch[3], 10);
        return interpolate(r, g, b, fraction);
    }
    return color;
};
exports.getLighterColor = getLighterColor;
